/**
 * Client AdaptiveRoute
 *
 * Thin wrapper around shared `AdaptiveRoute`.
 * Layout components live in `client/src/layouts/*`.
 *
 * IMPORTANT: shared must not import client UI.
 */

import SharedAdaptiveRoute from '../../../../shared/components/AdaptiveRoute/AdaptiveRoute.js';
import { useAuth } from '../../context/AuthContext';

import B2BLayout from '../../layouts/B2BLayout';
import B2CLayout from '../../layouts/B2CLayout';
import ProtectedRoute from '../ProtectedRoute';

const AdaptiveRoute = ({
  children,
  forceLayout,
  requireAuth = false,
  requireB2B = false,
}) => {
  const { getUserType, user } = useAuth();

  return (
    <SharedAdaptiveRoute
      getUserType={getUserType}
      user={user}
      B2CLayout={B2CLayout}
      B2BLayout={B2BLayout}
      ProtectedRoute={ProtectedRoute}
      requireAuth={requireAuth}
      requireB2B={requireB2B}
      forceLayout={forceLayout}
    >
      {children}
    </SharedAdaptiveRoute>
  );
};

export default AdaptiveRoute;
